/**
 * championVisualBoot — Register mesh + painter for OCP kits (P3-21+ / SPY-30).
 */
import { ChampionMeshRegistry } from './factory/championMeshRegistry.js';
import { ChampionModelRegistry } from './canvas/championModelRegistry.js';
import { createAnnieMesh } from './factory/meshes/annieMesh.js';
import { createSivirMesh } from './factory/meshes/sivirMesh.js';
import { createDariusMesh } from './factory/meshes/dariusMesh.js';
import { createSettMesh } from './factory/meshes/settMesh.js';
import { createJaxMesh } from './factory/meshes/jaxMesh.js';
import { createLuxMesh } from './factory/meshes/luxMesh.js';
import { createBrandMesh } from './factory/meshes/brandMesh.js';
import { createVeigarMesh } from './factory/meshes/veigarMesh.js';
import { createSorakaMesh } from './factory/meshes/sorakaMesh.js';
import { createLuluMesh } from './factory/meshes/luluMesh.js';
import { createNamiMesh } from './factory/meshes/namiMesh.js';
import { createEzrealMesh } from './factory/meshes/ezrealMesh.js';
import { createCaitlynMesh } from './factory/meshes/caitlynMesh.js';
import { createZedMesh } from './factory/meshes/zedMesh.js';
import { createKatarinaMesh } from './factory/meshes/katarinaMesh.js';
import { createYasuoMesh } from './factory/meshes/yasuoMesh.js';
import { createRivenMesh } from './factory/meshes/rivenMesh.js';
import { createIreliaMesh } from './factory/meshes/ireliaMesh.js';
import { AnniePainter } from './canvas/painters/anniePainter.js';
import { SivirPainter } from './canvas/painters/sivirPainter.js';
import { DariusPainter } from './canvas/painters/dariusPainter.js';
import { SettPainter } from './canvas/painters/settPainter.js';
import { JaxPainter } from './canvas/painters/jaxPainter.js';
import { LuxPainter } from './canvas/painters/luxPainter.js';
import { BrandPainter } from './canvas/painters/brandPainter.js';
import { VeigarPainter } from './canvas/painters/veigarPainter.js';
import { SorakaPainter } from './canvas/painters/sorakaPainter.js';
import { LuluPainter } from './canvas/painters/luluPainter.js';
import { NamiPainter } from './canvas/painters/namiPainter.js';
import { EzrealPainter } from './canvas/painters/ezrealPainter.js';
import { CaitlynPainter } from './canvas/painters/caitlynPainter.js';
import { ZedPainter } from './canvas/painters/zedPainter.js';
import { KatarinaPainter } from './canvas/painters/katarinaPainter.js';
import { YasuoPainter } from './canvas/painters/yasuoPainter.js';
import { RivenPainter } from './canvas/painters/rivenPainter.js';
import { IreliaPainter } from './canvas/painters/ireliaPainter.js';

export const P3_21_VISUAL_KEYS = ['annie', 'sivir'];
export const SPY30_FIGHTER_VISUAL_KEYS = ['darius', 'sett', 'jax'];
export const SPY110_MAGE_VISUAL_KEYS = ['lux', 'brand', 'veigar'];
export const SPY210_SUPPORT_VISUAL_KEYS = ['soraka', 'lulu', 'nami'];
export const SPY310_ADC_VISUAL_KEYS = ['ezreal', 'caitlyn'];
export const SPY610_ASSASSIN_VISUAL_KEYS = ['zed', 'katarina'];
export const SPY810_SKIRMISHER_VISUAL_KEYS = ['yasuo', 'riven', 'irelia'];

export function registerP321ChampionVisuals() {
  ChampionMeshRegistry.register('annie', (team) => createAnnieMesh(team));
  ChampionMeshRegistry.register('sivir', (team) => createSivirMesh(team));
  ChampionModelRegistry.register('annie', AnniePainter);
  ChampionModelRegistry.register('sivir', SivirPainter);
}

export function registerSpy30FighterVisuals() {
  ChampionMeshRegistry.register('darius', (team) => createDariusMesh(team));
  ChampionMeshRegistry.register('sett', (team) => createSettMesh(team));
  ChampionMeshRegistry.register('jax', (team) => createJaxMesh(team));
  ChampionModelRegistry.register('darius', DariusPainter);
  ChampionModelRegistry.register('sett', SettPainter);
  ChampionModelRegistry.register('jax', JaxPainter);
}

export function registerSpy110MageVisuals() {
  ChampionMeshRegistry.register('lux', (team) => createLuxMesh(team));
  ChampionMeshRegistry.register('brand', (team) => createBrandMesh(team));
  ChampionMeshRegistry.register('veigar', (team) => createVeigarMesh(team));
  ChampionModelRegistry.register('lux', LuxPainter);
  ChampionModelRegistry.register('brand', BrandPainter);
  ChampionModelRegistry.register('veigar', VeigarPainter);
}

export function registerSpy210SupportVisuals() {
  ChampionMeshRegistry.register('soraka', (team) => createSorakaMesh(team));
  ChampionMeshRegistry.register('lulu', (team) => createLuluMesh(team));
  ChampionMeshRegistry.register('nami', (team) => createNamiMesh(team));
  ChampionModelRegistry.register('soraka', SorakaPainter);
  ChampionModelRegistry.register('lulu', LuluPainter);
  ChampionModelRegistry.register('nami', NamiPainter);
}

export function registerSpy310AdcVisuals() {
  ChampionMeshRegistry.register('ezreal', (team) => createEzrealMesh(team));
  ChampionMeshRegistry.register('caitlyn', (team) => createCaitlynMesh(team));
  ChampionModelRegistry.register('ezreal', EzrealPainter);
  ChampionModelRegistry.register('caitlyn', CaitlynPainter);
}

export function registerSpy610AssassinVisuals() {
  ChampionMeshRegistry.register('zed', (team) => createZedMesh(team));
  ChampionMeshRegistry.register('katarina', (team) => createKatarinaMesh(team));
  ChampionModelRegistry.register('zed', ZedPainter);
  ChampionModelRegistry.register('katarina', KatarinaPainter);
}

export function registerSpy810SkirmisherVisuals() {
  ChampionMeshRegistry.register('yasuo', (team) => createYasuoMesh(team));
  ChampionMeshRegistry.register('riven', (team) => createRivenMesh(team));
  ChampionMeshRegistry.register('irelia', (team) => createIreliaMesh(team));
  ChampionModelRegistry.register('yasuo', YasuoPainter);
  ChampionModelRegistry.register('riven', RivenPainter);
  ChampionModelRegistry.register('irelia', IreliaPainter);
}

registerP321ChampionVisuals();
registerSpy30FighterVisuals();
registerSpy110MageVisuals();
registerSpy210SupportVisuals();
registerSpy310AdcVisuals();
registerSpy610AssassinVisuals();
registerSpy810SkirmisherVisuals();
